import React from 'react';
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Upload, X } from 'lucide-react';

import {
  commitmentLabel,
  documentTypeOptions,
  supplierLabel,
} from './selloutUtils';

export default function SellOutDocumentHeaderForm({
  form,
  onChange,
  suppliers,
  selectedSupplier,
  commitments,
  selectedCommitment,
  loadingSuppliers,
  loadingCommitments,
  disabled,
}) {
  const setValue = (key, value) => onChange({ [key]: value });

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5}>
        <Autocomplete
          fullWidth
          options={suppliers}
          value={selectedSupplier}
          loading={loadingSuppliers}
          disabled={disabled}
          onChange={(_, supplier) => onChange({
            supplier_id: supplier?.id || null,
            commitment_id: null,
            linked_invoice_id: null,
          })}
          getOptionLabel={supplierLabel}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => <TextField {...params} size="small" label="Proveedor" />}
        />
        <TextField
          select
          size="small"
          label="Tipo documento"
          value={form.document_type}
          disabled={disabled}
          onChange={(event) => setValue('document_type', event.target.value)}
          sx={{ minWidth: { md: 230 } }}
        >
          {documentTypeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5}>
        <TextField
          size="small"
          label="Numero"
          value={form.number || ''}
          disabled={disabled}
          onChange={(event) => setValue('number', event.target.value)}
          sx={{ flex: 1 }}
        />
        <TextField
          size="small"
          label="Serie"
          value={form.series || ''}
          disabled={disabled}
          onChange={(event) => setValue('series', event.target.value)}
          sx={{ flex: 1 }}
        />
        <TextField
          size="small"
          type="date"
          label="Fecha"
          value={form.date || ''}
          disabled={disabled}
          onChange={(event) => setValue('date', event.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: { md: 170 } }}
        />
        <TextField
          size="small"
          type="number"
          label="Total"
          value={form.total || ''}
          disabled={disabled}
          onChange={(event) => setValue('total', event.target.value)}
          inputProps={{ min: 0, step: '0.01' }}
          sx={{ minWidth: { md: 160 } }}
        />
      </Stack>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} alignItems={{ md: 'center' }}>
        <Autocomplete
          fullWidth
          options={commitments}
          value={selectedCommitment}
          loading={loadingCommitments}
          disabled={disabled || !form.supplier_id}
          onChange={(_, commitment) => setValue('commitment_id', commitment?.id || null)}
          getOptionLabel={commitmentLabel}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => <TextField {...params} size="small" label="Promesa Sell Out opcional" />}
        />

        <Box sx={{ minWidth: { md: 260 } }}>
          <Button component="label" variant="outlined" startIcon={<Upload size={17} />} disabled={disabled} fullWidth>
            Archivo
            <input
              hidden
              type="file"
              onChange={(event) => setValue('file', event.target.files?.[0] || null)}
            />
          </Button>
          {form.file ? (
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mt: 0.75, minWidth: 0 }}>
              <Typography variant="caption" color="text.secondary" noWrap title={form.file.name}>
                {form.file.name}
              </Typography>
              <Button size="small" color="inherit" startIcon={<X size={14} />} onClick={() => setValue('file', null)}>
                Quitar
              </Button>
            </Stack>
          ) : null}
        </Box>
      </Stack>

      <TextField
        size="small"
        multiline
        minRows={2}
        label="Comentario"
        value={form.comment || ''}
        disabled={disabled}
        onChange={(event) => setValue('comment', event.target.value)}
      />
    </Stack>
  );
}
